import { useCallback } from 'react';

import {
  PaymentMethodType,
  PaymentProcessingType,
  type TransactionResponse,
} from 'api/payments';
import type { Popup } from 'config/types.ts';
import { useNotifications, usePopups } from 'store';

export type UsePaymentNotificationProps = {
  imageSources: Record<PropertyKey, string | undefined>;
  paymentData?: TransactionResponse;
  paymentMethod: PaymentMethodType;
  successNotify?: (paymentData: TransactionResponse) => void;
};

export const useSuccessNotification = ({
  imageSources,
  paymentMethod,
}: UsePaymentNotificationProps) => {
  const [{ add }] = useNotifications();
  const { addPopup } = usePopups();
  const isDeposit = paymentMethod === PaymentMethodType.DEPOSIT;
  const popupProps = {
    type: 'default',
    immediate: true,
    closeByBackdrop: true,
  } as Popup;

  const successNotify = useCallback(
    (paymentData: TransactionResponse) => {
      if (paymentData) {
        const { processingType } = paymentData;

        if (processingType === PaymentProcessingType.POPUP) {
          popupProps.contentType = isDeposit ? 'deposit' : 'withdrawal';
          popupProps.data = {
            ...paymentData,
            imageSources,
          };
          addPopup(popupProps);
          return;
        }
      }

      add({
        text: isDeposit ? 'Success deposit' : 'Success withdrawal',
      });
    },
    [add, addPopup, imageSources, isDeposit, popupProps],
  );

  return successNotify;
};
